import { render, staticRenderFns } from "./carousel-controls.vue?vue&type=template&id=db20970e&"
import script from "./carousel-controls.vue?vue&type=script&lang=js&"
export * from "./carousel-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db20970e')) {
      api.createRecord('db20970e', component.options)
    } else {
      api.reload('db20970e', component.options)
    }
    module.hot.accept("./carousel-controls.vue?vue&type=template&id=db20970e&", function () {
      api.rerender('db20970e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/carousel/carousel-controls.vue"
export default component.exports